var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['header-bet', _vm.outcomesClass ]},[_c('div',{staticClass:"header-bet-inner-wrap"},[_c('div',{staticClass:"bet-section-display-id"},[_vm._v(" "+_vm._s(_vm.bet.displayId)+" ")]),_c('div',{ref:"betNameDiv",class:['bet-section-name', { 'long-name': _vm.longBetName }]},[_c('span',{ref:"betNameSpan"},[_vm._v(_vm._s(_vm.betName))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }